import { inject, Injectable } from '@angular/core';
import { DialogService, SuiDialogRef } from '@sui/dialog';

import { ServerFaultDialogComponent } from 'src/app/shared/components/server-fault-dialog/server-fault-dialog.component';
import { ApiError } from '../models/api-error.models';
import { ServerFaultPresenter } from './server-fault.token';

/**
 * The 5xx surface (WAP-1965): a server-fault dialog on the dialog stack, so a
 * fault during a save sits above the dialog that made the call. One at a time:
 * a second fault while it is open is ignored, the user already sees one.
 */
@Injectable({ providedIn: 'root' })
export class ServerFaultService implements ServerFaultPresenter {
  private readonly dialogs = inject(DialogService);
  private open: SuiDialogRef<unknown, void> | null = null;

  show(fault: ApiError): void {
    if (this.open) {
      return;
    }
    this.open = this.dialogs.openTabsDialog<ServerFaultDialogComponent, void>(
      ServerFaultDialogComponent,
      { data: { fault } },
    );
    this.open.closed.subscribe(() => (this.open = null));
  }
}
